<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="btnLoadList" (click)="getMailTemplates()" style="display:none">Get</button>
        <button type="button" (click)="show()" id="btn_AddNew" style="display:none">Add</button>
        <!--table-->
        <table #dataTable class="display" style="width:100%"></table>

        <div class="modal" id="mailtemplateModal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content" id="modal_contentArt">
              <!--popup Header-->
              <div class="modal-header">
                <h4 class="modal-title">{{title}}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <!--popup body-->
              <div class="modal-body" style="overflow:hidden !important;top:-15px;" id="popupbody">
                <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
                  <li class="nav-item"><a class="nav-link active" data-toggle="tab" name="TemplateDetails" href="#divTempDetails">Details</a></li>
                  <li class="nav-item"><a class="nav-link" data-toggle="tab" name="TemplateRemainder" href="#divTempRemdetails">Reminder</a></li>
                  <li class="nav-item" id="tab_btn"><button class="btn btn-outline-info waves-effect waves-light spAddIcon" (click)="showRemdetails()"><i class="fa fa-plus"></i> Add</button></li>
                </ul><br />
                <div class="tab-content">
                  <div class="tab-pane active" id="divTempDetails">
                    <div class="row">
                      <!--Left side panel-->
                      <div class="col-6 container-fluid">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-6">
                              <label for="Txt_ModuleName"> Module Name<em>*</em></label>
                              <input id="Txt_ModuleName" type="text" class="form-control" autocomplete="off" />
                            </div>
                            <div class="col-sm-6">
                              <label for="Txt_Template"> Template<em>*</em></label>
                              <input id="Txt_Template" type="text" class="form-control" autocomplete="off">
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-6">
                              <label for="Txt_MailContent"> MailContent<em>*</em></label>
                              <input id="Txt_MailContent" type="text" class="form-control" autocomplete="off">
                            </div>
                            <div class="col-sm-6">
                              <label for="ddlStageStatus">Stage Status</label>
                              <select id="ddlStageStatus" class="form-control">
                                <option value="0" selected disabled>Select Stage Status</option>
                                <option *ngFor="let item of StageStatus" value={{item.ID}}>
                                  {{item.Description}}
                                </option>
                              </select>
                            </div>

                          </div>
                        </div>

                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-6">
                              <label for="Txt_DisplayFromEmailid"> Display From EmailID</label>
                              <input id="Txt_DisplayFromEmailid" type="text" class="form-control" autocomplete="off">
                            </div>
                            <div class="col-sm-6">
                              <label for="Txt_FromEmailid">From EmailID<em>*</em></label>
                              <input id="Txt_FromEmailid" type="text" class="form-control" (change)="emailIdOnly($event)" autocomplete="off">
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="col-sm-12">
                            <label for="Txt_NotifyToEmail"> Notify To Email<em>*</em></label>
                            <input id="Txt_NotifyToEmail" type="text" class="form-control" autocomplete="off">
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="col-sm-12">
                            <label for="Txt_NotifyCCEmail">Notify CC Email</label>
                            <input id="Txt_NotifyCCEmail" type="text" class="form-control" autocomplete="off">
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="col-sm-12">
                            <label for="Txt_NotifyBCCEmail">Notify BCC Email</label>
                            <input id="Txt_NotifyBCCEmail" type="text" class="form-control" autocomplete="off">
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="cols row">
                            <div class="col-sm-6">
                              <label for="ddlLanguage">Language</label>
                              <select id="ddlLanguage" class="form-control">
                                <option value="0" selected>Select Language</option>
                                <option *ngFor="let item of LanguageList" value={{item.ID}}>
                                  {{item.Language}}
                                </option>
                              </select>
                            </div>
                            <div class="col-sm-6">
                              <label for="ddlCountry">Country</label>
                              <select id="ddlCountry" class="form-control">
                                <option value="0" selected>Select Country</option>
                                <option *ngFor="let item of CountryList" value={{item.ID}}>
                                  {{item.CountryName}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="col-sm-12">
                            <label for="ddlJournals">Journals</label>
                            <select id="ddlJournals" class="form-control" multiple>
                              <option *ngFor="let item of Journals" value={{item.ID}}>
                                {{item.Acronym}}
                              </option>
                            </select>
                          </div>
                        </div>
                        <br />
                      </div>

                      <!--Right side panel-->
                      <div class="col-6 container-fluid">
                        <div class="form-group">
                          <div class="col-12">
                            <label for="Txt_MailSubject">Mail Subject<em>*</em></label>
                            <textarea id="Txt_MailSubject" class="form-control" rows="2" autocomplete="off"> </textarea>
                          </div>
                          <div class="form-group col-12" id="Divmail">
                            <label for="Txt_MailBody">Mail Body<em>*</em></label>
                            <textarea id="Txt_MailBody" class="form-control rounded-0" autocomplete="off" data-origin="textarea"> </textarea>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="col-12">
                            <label for="Txt_MailSubject">Special Issue Mail Subject</label>
                            <textarea id="Txt_SIMailSubject" class="form-control" rows="2" autocomplete="off"> </textarea>
                          </div><br />
                          <div class="form-group col-12" id="SI_Divmail">
                            <label for="Txt_MailBody">Special Issue Mail Body</label>
                            <textarea id="Txt_SIMailBody" class="form-control rounded-0" autocomplete="off" data-origin="textarea"> </textarea>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-12">
                              <label for="Txt_MailDisclaimer">Mail Disclaimer</label>
                              <textarea id="Txt_MailDisclaimer" class="form-control" rows="3" autocomplete="off"> </textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="tab-pane" id="divTempRemdetails">
                    <button type="button" (click)="showRemdetails()" id="btnAddUpdate" style="display:none">Add/update</button>
                    <button type="button" (click)="DeleteRow()" id="btnDelete" style="display:none">Delete</button>
                    <!--Table-->
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group  fixTableHead">
                          <table class="table" style="width: 100%" id="tblMailtempRem">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Reminder Count</th>
                                <th>Interval Type</th>
                                <th>Subject</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody></tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!--Table end-->
                    <!--MailTemplate Reminder popup-->
                    <div class="modal" id="MailTempRem" [style.display]="showpopupModal ? 'block' : 'none'">
                      <div class="modal-dialog modal-xl custome-modal">
                        <div class="modal-content" id="modal_contentArt">
                          <!--popup Header-->
                          <div class="modal-header">
                            <h4 class="modal-title">{{RemTitle}}</h4>
                            <button type="button" class="close" data-dismiss="modal" (click)="hideRemPopup()">×</button>
                          </div>
                          <!--popup body-->
                          <div class="modal-body" style="overflow:hidden !important" id="popupbody">
                            <div class="row">
                              <!--Left side panel-->
                              <div class="col-6 container-fluid">
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-sm-6">
                                      <label for="Txt_RemainderCount">Reminder Count<em>*</em></label>
                                      <input id="Txt_RemainderCount" type="number" min="0" max="5" class="form-control" autocomplete="off">
                                    </div>
                                    <div class="col-sm-6">
                                      <label for="Txt_Sequence">Sequence<em>*</em></label>
                                      <input id="Txt_Sequence" type="number" min="0" max="5" class="form-control" autocomplete="off">
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-sm-6">
                                      <label for="ddl_IntervalType">Interval Type<em>*</em></label>
                                      <select id="ddl_IntervalType" class="form-control">
                                        <option value="0" selected disabled>Select Interval Type</option>
                                        <option value="Weekly" selected>Weekly</option>
                                        <option value="Daily" selected>Daily</option>
                                      </select>
                                    </div>
                                    <div class="col-sm-6">
                                      <label for="Txt_IntervalDay">IntervalDay<em>*</em></label>
                                      <input id="Txt_IntervalDay" type="number" min="0" max="5" class="form-control" autocomplete="off">
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="col-sm-12">
                                    <label for="Txt_FromEmail">From Email</label>
                                    <input id="Txt_FromEmail" type="text" class="form-control" (change)="emailIdOnly($event)" autocomplete="off">
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="col-sm-12">
                                    <label for="Txt_ToEmail">To Email<em>*</em></label>
                                    <input id="Txt_ToEmail" type="text" class="form-control" (change)="emailIdOnly($event)" autocomplete="off">
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="col-sm-12">
                                    <label for="Txt_CCEmail">CC Email</label>
                                    <input id="Txt_CCEmail" type="text" class="form-control" (change)="EmailValidation($event)" autocomplete="off">
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="col-sm-12">
                                    <label for="Txt_BCCEmail">BCC Email</label>
                                    <input id="Txt_BCCEmail" type="text" class="form-control" (change)="EmailValidation($event)" autocomplete="off">
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="col-sm-12">
                                    <label for="Txt_Signature">Signature</label>
                                    <input id="Txt_Signature" type="text" class="form-control" autocomplete="off">
                                  </div>
                                </div>
                              </div>
                              <!--Left side panel-->
                              <div class="col-6">
                                <div class="form-group">
                                  <div class="col-sm-12">
                                    <label for="Txt_Subject">Subject<em>*</em></label>
                                    <textarea id="Txt_Subject" class="form-control" rows="3" autocomplete="off"> </textarea>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-sm-12" id="DivRemMail">
                                      <label for="Txt_RemMailBody">Mail Body<em>*</em></label>
                                      <textarea id="Txt_RemMailBody" class="form-control" rows="3" autocomplete="off"> </textarea>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--popup body end-->
                          <div class="modal-footer">
                            <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideRemPopup()">Close</button>
                            <button type="button" class="btn btn-outline-success waves-effect  waves-light" title="Update" id="btnWF" (click)="addUpdateRemainder()">{{RemPopUpButtonText}}</button>
                          </div>
                        </div>
                        <div id="LoadingImagePopup1">
                          <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
                        </div>
                      </div>
                      <!--popup Loader-->
                    </div>

                    <!--MailTemplate Remainder popup end-->
                  </div>
                </div>
              </div>
              <!--popup body end-->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" title="Update" id="btnWF" (click)="UpdateTemplate()">{{popUpButtonText}}</button>
              </div>
            </div>
          </div>
          <!--popup Loader-->
          <div id="LoadingImageReopen">
            <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
